module.exports = __webpack_public_path__ + "static/media/ma.c91b7404.svg";